import {
    AbstractControl,
    AsyncValidator,
    ValidationErrors,
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, delay, map, switchMap } from 'rxjs/operators'; // Simulated service to check usernames
import { UsernameService } from '../services/username.service';

class UsernameExistsValidator implements AsyncValidator {
    constructor(
        private usernameService: UsernameService,
        private currentUsername: string = '',
    ) {}

    validate(control: AbstractControl): Observable<ValidationErrors | null> {
        // If the current username matches the form value, skip validation
        if (control.value === this.currentUsername) {
            return of(null);
        }
        return of(control.value).pipe(
            delay(500),
            switchMap((userName: string) =>
                this.usernameService.checkUsernameExists(userName).pipe(
                    debounceTime(500), // Optional: reduce server requests with a debounce
                    map((usernameExists: boolean) => {
                        return usernameExists ? { usernameTaken: true } : null;
                    }),
                ),
            ),
        );
    }
}

// Factory function
export function usernameExistsValidatorFactory(
    usernameService: UsernameService,
    currentUsername?: string,
): AsyncValidator {
    return new UsernameExistsValidator(usernameService, currentUsername);
}
